import { render, staticRenderFns } from "./AllRemittanceadvertisingManagementList.vue?vue&type=template&id=7183a395&"
import script from "./AllRemittanceadvertisingManagementList.vue?vue&type=script&lang=js&"
export * from "./AllRemittanceadvertisingManagementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports